module.exports = __webpack_public_path__ + "img/Logo-17.a3171693.svg";